// app/javascript/controllers/platform_tabs_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  
  static classes = [
    "active",   // e.g., "border-beb-accent text-beb-accent-text"
    "inactive"  // e.g., "border-transparent text-beb-fg-3"
  ]
  
  connect() {
    console.log("📑 Platform tabs controller connected")
    console.log("Tabs found:", this.tabTargets.length)
    console.log("Panels found:", this.panelTargets.length)
    
    // ✅ FIX #1: Show first tab OR restore active tab from cache
    const activeTab = this.tabTargets.find(tab => 
      tab.classList.contains('border-beb-accent') ||
      tab.getAttribute('aria-selected') === 'true'
    )
    
    if (activeTab) {
      this.showTab(activeTab)
    } else if (this.tabTargets.length > 0) {
      this.showTab(this.tabTargets[0])
    }
  }
  
  // ✅ Called via data-action (no addEventListener needed)
  switch(event) {
    event?.preventDefault()
    const clickedTab = event.currentTarget
    console.log("Tab clicked:", clickedTab.dataset.category)
    this.showTab(clickedTab)
  }
  
  // ✅ NEW: Keyboard navigation (accessibility)
  handleKeydown(event) {
    const currentTab = event.currentTarget
    const currentIndex = this.tabTargets.indexOf(currentTab)
    let nextIndex
    
    switch(event.key) {
      case 'ArrowLeft':
        event.preventDefault()
        nextIndex = currentIndex > 0 ? currentIndex - 1 : this.tabTargets.length - 1
        this.focusAndShowTab(this.tabTargets[nextIndex])
        break
        
      case 'ArrowRight':
        event.preventDefault()
        nextIndex = currentIndex < this.tabTargets.length - 1 ? currentIndex + 1 : 0
        this.focusAndShowTab(this.tabTargets[nextIndex])
        break
        
      case 'Home':
        event.preventDefault()
        this.focusAndShowTab(this.tabTargets[0])
        break
        
      case 'End':
        event.preventDefault()
        this.focusAndShowTab(this.tabTargets[this.tabTargets.length - 1])
        break
    }
  }
  
  focusAndShowTab(tab) {
    tab.focus()
    this.showTab(tab)
  }
  
  showTab(tab) {
    const category = tab.dataset.category
    
    if (!category) {
      console.error('Tab missing data-category:', tab)
      return
    }
    
    console.log("Showing category:", category)
    
    // ✅ Update tab styles using CSS classes
    this.tabTargets.forEach(t => {
      const isActive = t === tab
      
      if (isActive) {
        // Remove inactive classes
        t.classList.remove(
          'border-transparent', 
          'text-beb-fg-3', 
          'hover:text-beb-fg-2', 
          'hover:border-beb-line'
        )
        // Add active classes
        t.classList.add('border-beb-accent', 'text-beb-accent-text')
        t.setAttribute('aria-selected', 'true')
        t.setAttribute('tabindex', '0')
      } else {
        // Remove active classes
        t.classList.remove('border-beb-accent', 'text-beb-accent-text')
        // Add inactive classes
        t.classList.add(
          'border-transparent', 
          'text-beb-fg-3', 
          'hover:text-beb-fg-2', 
          'hover:border-beb-line'
        )
        t.setAttribute('aria-selected', 'false')
        t.setAttribute('tabindex', '-1')
      }
    })
    
    // ✅ Show/hide panels
    this.panelTargets.forEach(panel => {
      if (panel.dataset.category === category) {
        panel.classList.remove('hidden')
        panel.setAttribute('aria-hidden', 'false')
      } else {
        panel.classList.add('hidden')
        panel.setAttribute('aria-hidden', 'true')
      }
    })
  }
  
  disconnect() {
    console.log("📑 Platform tabs controller disconnected")
    // ✅ No cleanup needed - using data-action, not addEventListener
  }
}
